import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import { H1, H5 } from 'UIComponents/elements/headings';
import { FormattedMessage } from '../../../components/I18n';

const QuizEndScreen = ({
  onRetakeClick,
  totalQuestions,
  correctAnswers,
  className
}) => /*#__PURE__*/_jsx(UIFlex, {
  align: "center",
  className: className,
  direction: "column",
  justify: "center",
  wrap: "wrap",
  children: /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    direction: "column",
    justify: "center",
    wrap: "wrap",
    children: [/*#__PURE__*/_jsx(UIIllustration, {
      height: "150",
      name: "success-green"
    }), /*#__PURE__*/_jsx(H1, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.quiz.complete"
      })
    }), /*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.quiz.youScored",
        options: {
          totalQuestions,
          correctAnswers
        }
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "quiz-end-screen__retake-button",
      onClick: onRetakeClick,
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.quiz.retake"
      })
    })]
  })
});

export default QuizEndScreen;